<script>
/**
 * Earning Reports component
 */
export default {
  props: {
    statistics: { type: Object },
  },
  data() {
    return {
      totalSemana: 0,
      totalMes: 0,
      WeeklyEarning: {
        series: [72],
        chartOptions: {
          chart: {
            type: "radialBar",
            wight: 60,
            height: 60,
            sparkline: {
              enabled: true
            }
          },
          dataLabels: {
            enabled: false
          },
          colors: ["#5664d2"],
          stroke: {
            lineCap: "round"
          },
          plotOptions: {
            radialBar: {
              hollow: {
                margin: 0,
                size: "70%"
              },
              track: {
                margin: 0
              },
              dataLabels: {
                show: false
              }
            }
          }
        }
      },
      monthlyEarning: {
        series: [65],
        chartOptions: {
          chart: {
            type: "radialBar",
            wight: 60,
            height: 60,
            sparkline: {
              enabled: true
            }
          },
          dataLabels: {
            enabled: false
          },
          colors: ["#1cbb8c"],
          stroke: {
            lineCap: "round"
          },
          plotOptions: {
            radialBar: {
              hollow: {
                margin: 0,
                size: "70%"
              },
              track: {
                margin: 0
              },

              dataLabels: {
                show: false
              }
            }
          }
        }
      }
    };
  },
  mounted() {
    this.totalSemana = this.statistics.valorTotalAtendimentosSemana;
    this.totalMes = this.statistics.valorTotalAtendimentosMes;
  }
};
</script>

<template>
  <div class="card">
    <div class="card-body">
      <b-dropdown right toggle-class="arrow-none card-drop" class="float-right" variant="white">
        <template v-slot:button-content>
          <i class="mdi mdi-dots-vertical"></i>
        </template>
        <!-- item-->
        <b-dropdown-item>Relatório Vendas</b-dropdown-item>
        <!-- item-->
        <b-dropdown-item>Relatório Exportação</b-dropdown-item>
        <!-- item-->
        <b-dropdown-item>Receitas</b-dropdown-item>
        <!-- item-->
        <b-dropdown-item>Despesas</b-dropdown-item>
      </b-dropdown>

      <h4 class="card-title mb-4">Relatório de atendimentos</h4>
      <div class="text-center">
        <div class="row">
          <div class="col-sm-6">
            <div>
              <div class="mb-3">
                <apexchart
                  class="apex-charts"
                  height="60"
                  wight="60"
                  dir="ltr"
                  :series="WeeklyEarning.series"
                  :options="WeeklyEarning.chartOptions"
                ></apexchart>
              </div>
              <p class="text-muted text-truncate mb-2">Semanais</p>
              <h5 class="mb-0">R$ {{ parseFloat(totalSemana).toFixed(2) }}</h5>
            </div>
          </div>

          <div class="col-sm-6">
            <div class="mt-5 mt-sm-0">
              <div class="mb-3">
                <apexchart
                  class="apex-charts"
                  height="60"
                  wight="60"
                  dir="ltr"
                  :series="monthlyEarning.series"
                  :options="monthlyEarning.chartOptions"
                ></apexchart>
              </div>

              <p class="text-muted text-truncate mb-2">Mensais</p>
              <h5 class="mb-0">R$ {{ parseFloat(totalMes).toFixed(2) }}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>